/**
 * Post messages to parent window
 */
export default class MessagePropagator {
    /**
     * Post height & width in px
     *
     * @param {number} height
     * @param {number} width
     */
    static postSizing(height, width) {
        postMessage('iwcFrameResize' , {
            height: height,
            width: width
        })
    }

    /**
     * Post info, that start form is submitted
     *
     * @param {string} name
     * @param {string} mail
     */
    static postStartFormSubmit(name, mail) {
        postMessage('iwcStartFormSubmit', {
            name: name,
            mail: mail
        })
    }

    /**
     * Post request to open link
     *
     * @param {string} link
     */
    static postOpenExternalLink(link) {
        postMessage('iwcOpenExternalLink', {
            link: link
        })
    }
}

/**
 * Post a message to parent window in standard format
 *
 * @param {string} type
 * @param {object} data
 */
function postMessage(type, data) {
    window.parent.postMessage(JSON.stringify({
        type: type,
        data: data
    }), '*');
}